// Module
var code = "<div class=\"container-fluid\">\n  <div class=\"row\">\n    <div class=\"col-md-12\">\n      <h1>CATV 情報</h1>\n    </div>\n  </div>\n</div>\n";
// Exports
export default code;